import notifyError from '@/lib/notify-error';
import notifySuccess from '@/lib/notify-success';
import {
  findItems, removeItem, removeItems, hideItems,
} from '@/services/publicacao';
import { findTipospublicacao } from '@/services/tipospublicacao';
import { findTiposuporte } from '@/services/tiposuporte';
import { findIdiomas } from '@/services/idiomas';
import { findSegmentos } from '@/services/segmentos';
import { findAccounts } from '@/services/account';
import { baseURL } from '@/services/container';
import Router from '@/router';

export default {
  afterRouteUpdate({
    commit, rootState, dispatch, getters,
  }) {
    if (rootState.route.params.avancado === 'avancado') {
      commit('setSearchType', 'advanced');
    }
    if (getters.isAdmin || getters.isOperador) {
      dispatch('loadAccounts');
    }
    findTipospublicacao({ where: { base: 'S' } })
      .then(items => commit('setCollections', items));
    dispatch('findIdiomas');
    dispatch('findTiposuporte');
    dispatch('findSegmentos');
  },
  findIdiomas({ commit }) {
    findIdiomas()
      .then(items => commit('setIdiomas', items));
  },
  findSegmentos({ commit }) {
    findSegmentos({ where: { idCanalPadrao: 273 } })
      .then(items => commit('setSegmentos', items));
  },
  findTiposuporte({ commit }) {
    findTiposuporte({ order: 'descricao ASC' })
      .then(items => commit('setSuportes', items));
  },
  loadAccounts({ commit }) {
    const settings = {
      include: 'role',
    };
    return findAccounts(settings)
      .then((accounts) => {
        commit('setAccounts', accounts.items);
      });
  },
  loadItems({ commit, state, getters }, { $event, $vuetify }) {
    commit('setLoading', true);
    const settings = {
      include: ['suporteBase', 'tipoPublicacao', 'documentos', 'publicador'],
      ...state.filter,
    };
    if (!getters.hasPermission) {
      if (!settings.where) {
        settings.where = {};
      }
      settings.where.nivel = 'publico';
    }
    if ($event) {
      if ($event.itemsPerPage) {
        settings.limit = $event.itemsPerPage;
      }
      if ($event.page > 1) {
        settings.skip = ($event.page - 1) * $event.itemsPerPage;
      } else {
        delete settings.skip;
      }
      if ($event.sortBy.length) {
        if ($event.sortBy[0] === 'id') {
          if (getters.isAdmin || getters.isOperador) {
            $event.sortBy[0] = 'createdAt';
          } else {
            $event.sortBy[0] = 'dt_imagem';
          }
        }
        settings.order = `${$event.sortBy[0]} ${$event.sortDesc[0] ? 'DESC' : 'ASC'}`;
      }
      commit('setOptions', $event);
    }
    return findItems(settings)
      .then((items) => {
        commit('setItems', items.items);
        commit('setTotalItems', items.total);
        if ($vuetify) {
          $vuetify.goTo('#search-result');
        }
      })
      .catch(() => {
        commit('setLoading', false);
        notifyError();
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  onSimpleSearch({ commit, dispatch, state }, { form }) {
    let isDirty = false;
    form.inputs.forEach((input) => {
      if (input.isDirty) {
        isDirty = true;
      }
    });
    if (!isDirty) {
      notifyError('É necessário selecionar ao menos um campo para buscar!');
      return;
    }
    commit('patchOptions', { page: 1 });
    commit('setShowTable', true);
    dispatch('loadItems', { $event: state.options });
  },
  onPatchFilter({ commit }, $event) {
    commit('patchFilter', $event);
    if ($event.where && $event.where.nome) {
      commit('setGlobalSearch', $event.where.nome);
    }
  },
  onSidebarFilter({ commit, dispatch, state }, $event) {
    commit('patchOptions', { page: 1 });
    commit('setShowTable', true);
    commit('patchFilter', $event);
    dispatch('loadItems', { $event: state.options });
  },
  onAdvancedSearch({ commit, dispatch, state }) {
    commit('patchOptions', { page: 1 });
    commit('setShowTable', true);
    commit('setSearchType', 'simple');
    dispatch('loadItems', { $event: state.options });
  },
  onInputCollection({ commit }, collection) {
    commit('setCollection', collection);
  },
  onDeleteDialogInput({ commit }, dialog) {
    commit('setDeleteDialog', dialog);
  },
  onBulkDeleteDialogInput({ commit }, dialog) {
    commit('setBulkDeleteDialog', dialog);
  },
  onBulkHideDialogInput({ commit }, dialog) {
    commit('setBulkHideDialog', dialog);
  },
  onRegisterDialogInput({ commit }, dialog) {
    commit('setRegisterDialog', dialog);
  },
  onDeleteDialogOpen({ commit }, item) {
    commit('setDeleteDialog', true);
    commit('setDeleteItem', item);
  },
  onBulkDeleteDialogOpen({ commit }, items) {
    commit('setBulkDeleteDialog', true);
    commit('setBulkDeleteItems', items);
  },
  onSetBulkDeleteItems({ commit }, items) {
    commit('setBulkDeleteItems', items);
  },
  onBulkHideDialogOpen({ commit }, items) {
    commit('setBulkHideDialog', true);
    commit('setBulkHideItems', items);
  },
  onSearchTypeChange({ commit, getters }, type) {
    commit('setShowTable', false);
    commit('setFilter', getters.emptyFilter);
    commit('setSearchType', type);
  },
  onDelete({
    state, dispatch, commit,
  }) {
    commit('setLoading', true);
    return removeItem(state.deleteItem.id)
      .then(notifySuccess('Título deletado com sucesso'))
      .then(() => dispatch('loadItems', { $event: state.options }))
      .catch(notifyError())
      .finally(() => {
        commit('setLoading', false);
        commit('setDeleteDialog', false);
      });
  },
  onBulkDelete({
    state, dispatch, commit,
  }) {
    commit('setLoading', true);
    const ids = state.bulkDeleteItems.map(item => item.id);
    return removeItems(ids)
      .then(notifySuccess('Títulos deletados com sucesso'))
      .then(() => dispatch('loadItems', { $event: state.options }))
      .catch(notifyError())
      .finally(() => {
        commit('setLoading', false);
        commit('setBulkDeleteDialog', false);
        commit('setBulkDeleteItems', []);
      });
  },
  onBulkHide({
    state, dispatch, commit,
  }) {
    commit('setLoading', true);
    const ids = state.bulkHideItems.map(item => item.id);
    return hideItems(ids)
      .then(notifySuccess('Títulos ocultados com sucesso'))
      .then(() => dispatch('loadItems', { $event: state.options }))
      .catch(notifyError())
      .finally(() => {
        commit('setLoading', false);
        commit('setBulkHideDialog', false);
      });
  },
  onOpenItem({ dispatch, rootState, commit }, item) {
    if (rootState.auth.account) {
      return Router.push({ name: 'Acervo ver', params: { id: item.id } });
    }
    commit('setItem', item);
    return dispatch('onRegisterDialogInput', true);
  },
  onOpenFile({ rootState, dispatch, commit }, item) {
    if (rootState.auth.account) {
      window.open(`${baseURL}/download/${encodeURIComponent(item.arquivo.nomeInterno)}`, '_blank');
      return false;
    }
    commit('setItem', item);
    return dispatch('onRegisterDialogInput', true);
  },
  onRegisterAccountPatch({ commit }, $event) {
    commit('patchRegisterAccount', $event);
  },
  onRegister({ dispatch, state, commit }, formRef) {
    if (formRef.validate()) {
      commit('setRegisterLoading', true);
      const payload = state.registerAccount;
      dispatch('auth/signUp', payload, { root: true })
        .then(account => dispatch('auth/signIn', { email: account.email, password: payload.password }, { root: true }))
        .then(() => {
          dispatch('onRegisterDialogInput', false);
          if (state.item.id) {
            Router.push({ name: 'Acervo ver', params: { id: state.item.id } });
          } else {
            Router.push({ name: 'Acervo listar' });
          }
        })
        .catch((error) => {
          if (error.message && error.message.includes('Email already exists')) {
            notifyError('E-mail já cadastrado.');
          } else {
            notifyError('Erro ao criar usuário.');
          }
        })
        .finally(() => {
          commit('setRegisterLoading', false);
        });
    }
  },
};
